import { PROVIDER_API, providerReportPath, USE_MOCK_AUTH } from "../config/api";
import { apiRequest, unwrapApiEnvelope } from "./apiClient";

export async function fetchProviderReportCatalog(token) {
  if (USE_MOCK_AUTH || !token) return [];
  const json = await apiRequest(PROVIDER_API.reports, { method: "GET", token });
  const data = unwrapApiEnvelope(json);
  return Array.isArray(data?.reports) ? data.reports : [];
}

export async function fetchProviderReport(token, slug, params = {}) {
  if (USE_MOCK_AUTH || !token) {
    return { columns: [], rows: [], pagination: {}, filter_options: {}, report: null };
  }
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const suffix = search.toString() ? `?${search}` : "";
  const json = await apiRequest(`${providerReportPath(slug)}${suffix}`, { method: "GET", token });
  return unwrapApiEnvelope(json) || {};
}
